import clsx from 'clsx'
import React, { PropsWithChildren } from 'react'
import { NavLink } from 'react-router'
import Navigation from '@App/navigation'
import { ICONS } from '@Const/common'
import './index.scss'

interface NavBarWrapperProps {
    wrapperClass?: string
    accountingBlock?: React.ReactNode
    rightBlock?: React.ReactNode
    burgerBlock?: React.ReactNode
}

const NavBarWrapper = ({
    wrapperClass,
    accountingBlock,
    rightBlock,
    burgerBlock,
    children,
}: PropsWithChildren<NavBarWrapperProps>) => (
    <nav className={clsx('navigation-bar-component', wrapperClass)} data-testid="navigation-bar-component">
        <div className="accounting-block">
            <NavLink to={Navigation.home.root()} className="logo-link">
                <img src={ICONS.mlc_logo_black} alt="MLC Logo" />
            </NavLink>
            {accountingBlock}
        </div>
        {children}
        <div className="right-block">{rightBlock}</div>
        {burgerBlock}
    </nav>
)

export default NavBarWrapper
